import React from "react"; 
import Review from "./View/Components/Review"; // Import the Reviews component
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import Sidebar from "./View/Components/Sidebar/index";
import Header from "./View/Components/Header/index";
import PageNotFound from "./View/Pages/PageNotFound";
import Dashboard from "./View/Components/Dashboard";
import Brands from "./View/Components/Brands";
import Statistics from "./View/Components/Statistics";
import Settings from "./View/Components/Settings";
import Login from "./View/Pages/Login";
import OrderList from "./View/Components/Orders";
import OrderDetails from "./View/Components/Orders/OrderDetails";
import ProductList from "./View/Components/Products/ProductList";
import ProductGrid from "./View/Components/Products/ProductGrid";
import ProductGrid2 from "./View/Components/Products/ProductGrid2";
import Categories from "./View/Components/Products/Categories";
import AddProduct1 from "./View/Components/AddProduct/AddProduct1";
import AddProduct2 from "./View/Components/AddProduct/AddProduct2";
import AddProduct3 from "./View/Components/AddProduct/AddProduct3";
import AddProduct4 from "./View/Components/AddProduct/AddProduct4";
import Transaction1 from "./View/Components/Transactions/Transaction1";
import Transaction2 from "./View/Components/Transactions/Transaction2";
import SellerCards from "./View/Components/Sellers/SellerCards";
import SellerList from "./View/Components/Sellers/SellerList";
// import SellerProfile from "./View/Components/Sellers/SellerProfile";

const PrivateRoute = ({ element }) => {
  const { encryptedToken } = useSelector((state) => state.auth);

  return encryptedToken ? element : <Navigate to="/login" replace />;
};

const AppLayout = ({ children }) => {
  const location = useLocation();
  const hideSidebarAndHeader = ["/login", "/signup"].includes(
    location.pathname
  );

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      {!hideSidebarAndHeader && <Sidebar />}
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        {!hideSidebarAndHeader && <Header />}
        <Box sx={{ flexGrow: 1, p: 2 }}>{children}</Box>
      </Box>
    </Box>
  );
};

const App = () => {
  const { encryptedToken } = useSelector((state) => state.auth);

  return (
    <Router>
      <AppLayout>
        <Routes>
          <Route
            path="/"
            element={
              encryptedToken ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          <Route path="/login" element={<Login />} />
          <Route
            path="/login"
            element={encryptedToken ? <Navigate to="/login" replace /> : <Login />}
          />
        

          <Route
            path="/dashboard"
            element={<PrivateRoute element={<Dashboard />} />}
          />
          <Route
            path="/brands"
            element={<PrivateRoute element={<Brands />} />}
          />
          <Route
            path="/review"
            element={<PrivateRoute element={<Review />} />}
          />
          <Route
            path="/statistics"
            element={<PrivateRoute element={<Statistics />} />}
          />
          <Route
            path="/settings"
            element={<PrivateRoute element={<Settings />} />}
          />
          <Route
            path="/products/productlist"
            element={<PrivateRoute element={<ProductList />} />}
          />
          <Route
            path="/products/productgrid"
            element={<PrivateRoute element={<ProductGrid />} />}
          />
          <Route
            path="/products/productgrid2"
            element={<PrivateRoute element={<ProductGrid2 />} />}
          />
          <Route
            path="/products/categories"
            element={<PrivateRoute element={<Categories />} />}
          />
          <Route
            path="/addproduct/addproduct1"
            element={<PrivateRoute element={<AddProduct1 />} />}
          />
          <Route
            path="/addproduct/addproduct2"
            element={<PrivateRoute element={<AddProduct2 />} />}
          />
          <Route
            path="/addproduct/addproduct3"
            element={<PrivateRoute element={<AddProduct3 />} />}
          />
          <Route
            path="/addproduct/addproduct4"
            element={<PrivateRoute element={<AddProduct4 />} />}
          />
          <Route
            path="/addproduct/addproduct4"
            element={<PrivateRoute element={<AddProduct4 />} />}
          />
          <Route
            path="/transactions/transaction1"
            element={<PrivateRoute element={<Transaction1 />} />}
          />
          <Route
            path="/orders/orderlist"
            element={<PrivateRoute element={<OrderList />} />}
          />
          <Route
            path="/orders/orderdetails"
            element={<PrivateRoute element={<OrderDetails />} />}
          />
          <Route
            path="/transactions/transaction1"
            element={<PrivateRoute element={<Transaction1 />} />}
          />
          <Route
            path="/transactions/transations2"
            element={<PrivateRoute element={<Transaction2 />} />}
          />
          <Route
            path="/sellers/sellercards"
            element={<PrivateRoute element={<SellerCards />} />}
          />
          <Route
            path="/sellers/sellerlist"
            element={<PrivateRoute element={<SellerList />} />}
          />
          {/* <Route
            path="/sellers/sellerprofile"
            element={<PrivateRoute element={<SellerProfile />} />}
          /> */}
          {/* <Route
            path="/review"
            element={<PrivateRoute element={<Review />} />}
          /> */}

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </AppLayout>
    </Router>
  );
};

export default App;
